const SectionWiseFetchDetailsTypes = {
	/** ****************************** SECTION WISE FETCH *********************** */
	SECTION_WISE_FETCH_START: 'section_wise_fetch_start',
	SECTION_WISE_FETCH_SUCCESS: 'section_wise_fetch_success',
	SECTION_WISE_FETCH_FAILURE: 'section_wise_fetch_failure',
	SECTION_WISE_FETCH_RESPONSE_CHANGED: 'section_wise_fetch_response_changed',
	SECTION_WISE_FETCH_RESPONSE_REST_START: 'section_wise_fetch_response_rest_start',
};

export default SectionWiseFetchDetailsTypes;
